<template>
  <div class="personal-exam-record-card-comp">
    <div class="header">
      <div class="title">{{ seq }}、{{ name }}</div>
    </div>

    <div class="overview">
      <div class="item" v-for="(item, index) in overviewInfo" :key="index">
        <div class="name">{{ item.name }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>

    <div class="questions" v-for="(question, index) in questionInfo" :key="index">
      <div class="question" :class="[calcQuestionClass(question.status)]">
        <div class="content">{{ index + 1 }}、{{ question.subject }}</div>

        <div class="options">
          <div
            class="option"
            :class="calcStatus(question, option.id)"
            v-for="(option, index) in question.options"
            :key="index"
          >
            {{ no[index] }} : {{ option.content }}
          </div>
        </div>

        <div class="answer">
          <span class="label">答案：</span>
          {{ showRightSeq(question) }}
        </div>

        <div class="explanation" v-if="question.explanation">解析：{{ question.explanation }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { IChallengeMaxPaperRecord, IStudentChallengeRecordQuestion } from 'kuaidong-model'
@Component({
  components: {},
})
export default class PersonalExamRecordCard extends BaseComponent {
  @Prop({ type: Object, required: true })
  paperRecord!: IChallengeMaxPaperRecord

  @Prop({ type: Number, required: true })
  seq!: number

  @Prop({ type: String, required: true })
  name!: string
  no = ['A', 'B', 'C', 'D']

  get overviewInfo() {
    return [
      {
        name: '全部',
        value: this.paperRecord.total_quantity,
      },
      {
        name: '正确',
        value: this.paperRecord.correct_quantity,
      },
      {
        name: '错误',
        value: this.paperRecord.wrong_quantity,
      },
      {
        name: '评分',
        value: this.paperRecord.star_score,
      },
    ]
  }

  get questionInfo() {
    return this.paperRecord.questions
  }

  calcQuestionClass(status: number) {
    if (status === 1) {
      return 'right'
    } else if (status === 2) {
      return 'wrong'
    } else {
      return null
    }
  }

  showRightSeq(question: IStudentChallengeRecordQuestion) {
    const rightOptionIndex = question.options.findIndex((item) => {
      return item.is_right
    })
    if (rightOptionIndex !== -1) {
      return this.no[rightOptionIndex]
    } else {
      return '-'
    }
  }

  answerStatus(status: number) {
    switch (status) {
      case 0:
        return 'un-do'
      case 1:
        return 'right'
      default:
        return 'wrong'
    }
  }

  isUserOption(question: IStudentChallengeRecordQuestion, optionId: string) {
    return question.user_option_ids.includes(optionId)
  }

  calcStatus(question: IStudentChallengeRecordQuestion, optionId: string) {
    return this.isUserOption(question, optionId) && this.answerStatus(question.status)
  }
}
</script>
<style lang="less">
.personal-exam-record-card-comp {
  background: #fff;
  border-radius: 8px;
  padding: 16px;

  > .header {
    display: flex;
    justify-content: flex-start;
    > .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #4d4d4d;
    }
  }

  > .overview {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    > .item {
      display: flex;
      flex-direction: column;
      padding: 8px 22px;
      > .value {
        font-weight: 700;
        font-size: 24px;
        line-height: 26px;
        color: #2d2f33;
        margin-top: 6px;
      }
      &:nth-child(3) {
        > .value {
          font-weight: 700;
          font-size: 24px;
          line-height: 26px;
          color: #f24b53;
        }
      }

      > .name {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #9da2a9;
      }
    }
  }

  > .questions {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 582px;

    > .question {
      text-align: left;
      padding: 12px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #5e6166;
      background: #f7f8fa;
      border-radius: 8px;
      box-sizing: border-box;
      margin-top: 16px;
      &.right {
        background: rgba(59, 181, 40, 0.1);
      }
      &.wrong {
        background: rgba(242, 75, 83, 0.1);
      }
      > .options {
        > .option {
          margin-top: 10px;
          &.right {
            color: #3bb528;
          }
          &.wrong {
            color: #f24b53;
          }
        }
      }
      > .answer {
        margin-top: 20px;
        > .label {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #3bb528;
        }
      }
      > .explanation {
        margin: 4px 0 0 0;
        line-height: 17px;
        font-size: 12px;
        color: #8f8f8f;
      }
    }
  }
}
</style>
